const RANGES = ['C1-C3','C2-C4','C3-C5','C4-C6','C5-C7'];
export default RANGES;